module.exports = __webpack_public_path__ + "static/server-aa93be1d4aa0e518e9b2398967bfb769.jpg";